import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCaretDown } from '@fortawesome/pro-solid-svg-icons/faCaretDown';
import { faCaretUp } from '@fortawesome/pro-solid-svg-icons/faCaretUp';
import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { Button } from '../../button';
import style from './style.module.less';

const arrowUpButtonProperties = {
  'data-testid': 'number-arrow-up',
};
const arrowDownButtonProperties = {
  'data-testid': 'number-arrow-down',
};

export const ArrowButtonGroup = ({
  disabled = false,
  increment,
  decrement,
  shouldDisableDecrementOnly = false,
  shouldDisableIncrementOnly = false,
  disabledDecrementTooltipMessage = null,
  disabledIncrementTooltipMessage = null,
}) => {
  const classes = classnames(style['arrow-buttons'], {
    [style.disabled]: disabled,
  });
  return (
    <div className={classes}>
      <Button
        className={style['arrow-button']}
        disabled={disabled || shouldDisableIncrementOnly}
        disabledTooltipMessage={disabledIncrementTooltipMessage}
        disabledTooltipMessagePosition='top'
        onClick={increment}
        otherProperties={arrowUpButtonProperties}
        tabIndex={-1}
        theme='unstyled'
      >
        <FontAwesomeIcon className={style['arrow-top']} icon={faCaretUp} />
      </Button>
      <Button
        className={style['arrow-button']}
        disabled={disabled || shouldDisableDecrementOnly}
        disabledTooltipMessage={disabledDecrementTooltipMessage}
        disabledTooltipMessagePosition='bottom'
        onClick={decrement}
        otherProperties={arrowDownButtonProperties}
        tabIndex={-1}
        theme='unstyled'
      >
        <FontAwesomeIcon className={style['arrow-bottom']} icon={faCaretDown} />
      </Button>
    </div>
  );
};

ArrowButtonGroup.propTypes = {
  increment: PropTypes.func.isRequired,
  decrement: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  shouldDisableDecrementOnly: PropTypes.bool,
  shouldDisableIncrementOnly: PropTypes.bool,
  disabledDecrementTooltipMessage: PropTypes.node,
  disabledIncrementTooltipMessage: PropTypes.node,
};
